import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';

export interface PaymentMethodPoint {
  label: string;
  value: number;
  color: string;
}

@Component({
  selector: 'app-payment-methods-chart',
  standalone: true,
  imports: [CommonModule, BaseChartDirective],
  templateUrl: './payment-methods-chart.component.html',
  styleUrl: './payment-methods-chart.component.scss',
})
export class PaymentMethodsChartComponent implements OnInit {
  @Input() title = 'Payment Channels';
  @Input() methods: PaymentMethodPoint[] = [];

  doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '18%',
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#1F2937',
        titleColor: '#F9FAFB',
        bodyColor: '#F9FAFB',
        padding: 12,
        cornerRadius: 8,
        displayColors: true,
        callbacks: {
          label: (context) => `${context.label}: ${context.parsed}%`,
        },
      },
    },
    animation: { animateRotate: true, duration: 1000, easing: 'easeOutQuart' },
    elements: {
      arc: { borderWidth: 0 },
    },
  };

  doughnutChartData: ChartData<'doughnut'> = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        hoverBackgroundColor: [],
        borderWidth: 0,
        hoverOffset: 4,
      },
    ],
  };

  ngOnInit(): void {
    this.updateChartData();
  }

  ngOnChanges(): void {
    this.updateChartData();
  }

  getPercent(value: number): string {
    const safe = Number.isFinite(value) ? value : 0;
    return `${safe.toFixed(0)}%`;
  }

  private updateChartData(): void {
    if (!this.methods?.length) return;
    this.doughnutChartData = {
      labels: this.methods.map((m) => m.label),
      datasets: [
        {
          data: this.methods.map((m) => m.value),
          backgroundColor: this.methods.map((m) => m.color),
          hoverBackgroundColor: this.methods.map((m) => m.color),
          borderWidth: 0,
          hoverOffset: 4,
        },
      ],
    };
  }
}

